import { render, staticRenderFns } from "./DxCodeManagement.vue?vue&type=template&id=c1767266&scoped=true"
import script from "./DxCodeManagement.vue?vue&type=script&lang=js"
export * from "./DxCodeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1767266",
  null
  
)

export default component.exports